import gql from 'graphql-tag';
export const ChildCheckinDetail = gql `
    query ChildCheckinDetail($childCheckinId: ChildCheckinId!) {
        attendance {
            childCheckins {
                byId(childCheckinId: $childCheckinId) {
                    id
                    checkinTime
                    checkoutTime
                    checkedInBy {
                        id
                        name {
                            fullName
                        }
                    }
                    checkedOutBy {
                        id
                        name {
                            fullName
                        }
                    }
                    kinderConnectMedia {
                        atCheckin {
                            photoUrl
                            signatureUrl
                            latitude
                            longitude
                        }
                        atCheckout {
                            photoUrl
                            signatureUrl
                            latitude
                            longitude
                        }
                    }
                }
            }
        }
    }
`;
